import { apiGet } from '../../fetch/apiService';

export const getDevices = (deviceType) => {
	return apiGet('plecto-device/device-list/', { devices: deviceType }, { internalApi: true });
};
